import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Components/header/header';
import PMSideLayout from './pMSideBarlayout';
const MainPMLayout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        const isMainLayoutActive = location.pathname === "/Management/";
        if (isMainLayoutActive) {
            document.body.classList.add('body-with-sidebar');
        } else {
            document.body.classList.remove('body-with-sidebar');
        }
    }, [location.pathname]);

    return (
        <PMSideLayout>
            <Header />
            <div className='mainbdy'>{children}</div>
        </PMSideLayout>
    );
};

export default MainPMLayout;
